<template>
  <div class="item pointer">
    <img :src="data.courseLogo" class="item-cover" />
    <div class="item-name">{{ data.courseName }}</div>
    <div>
      <el-button type="primary" @click="itemClick(data)">进入课程</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    itemClick(item) {
      this.$router.push({
        name: "onlineTrainDetail",
        query: { id: item.courseId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  background: white;
  padding: 15px;
  &-cover {
    width: 100%;
    height: 200px;
    margin-bottom: 10px;
  }
  &-name {
    font-weight: bold;
    margin-bottom: 12px;
  }
}
</style>
